import React from 'react';
import Button from '@mui/material/Button';
import { type GhostPartner } from 'shared/utils/partnerUser';
import { publishedReportUrl } from './utils';

interface ReportStatusModalProps {
  /** Selects the `cn-*` or `bb-*` theme class names. */
  partner: GhostPartner;
  title: string;
  description: string;
  buttonLabel: string;
  reportId: number | null;
}

/** "Report Published" / "Report Completed" overlay with a link to the public report. */
const ReportStatusModal: React.FC<ReportStatusModalProps> = ({
  partner,
  title,
  description,
  buttonLabel,
  reportId,
}) => (
  <div className={`${partner}-modal-overlay`}>
    <div className={`${partner}-modal-content`}>
      <h2 className={`${partner}-modal-title`}>{title}</h2>
      <p className={`${partner}-modal-description`}>{description}</p>
      <div className={`${partner}-action-buttons-row`}>
        {reportId && (
          <Button
            onClick={() => {
              window.location.href = publishedReportUrl(reportId);
            }}
            variant="contained"
            color="primary"
            size="medium"
            className={partner === 'cn' ? 'cn-share-button' : 'bb-action-button'}
          >
            {buttonLabel}
          </Button>
        )}
      </div>
    </div>
  </div>
);

export default ReportStatusModal;
